import ContextMenuItem from '../ContextMenuItem'

/**
 * OpenLoad context menu item.
 *
 * @author Alejandro Sanchez <asanchez@boltsystem.com>
 */
export default class OpenLoad extends ContextMenuItem {
    /**
     * Get the action callback function.
     *
     * @return {Function}
     */
    action() {
        return () => {
            const id = this.params.node.data.id

            if (id) {
                const url = `/index.cfm?module=dispatch&template=dspLoad&intLoadId=${id}`

                window.open(url, '_blank', 'noreferrer')
            }
        }
    }

    /**
     * The name of the menu item to display.
     *
     * @return {String}
     */
    name() {
        return 'Open in New Tab'
    }

    /**
     * The tooltip to display on hover.
     *
     * @return {String?}
     */
    tooltip() {
        return 'Click to open this load in a new tab'
    }
}
